<template>
  <div class="status">
    <div>{{ $t('status') }}:</div>
    <template v-for="(item, index) in values">
      <FontAwesomeIcon v-if="index" :icon="['fal', 'angle-right']" :key="item + '-icon'" />
      <div
        :key="item"
        class="status__item"
        :class="{ 'status__item--active': isActive(item, value), ['status__item--' + item]: true }"
      >
        {{ $t('shopContractStatus' + Capitalize(item)) }}
      </div>
    </template>
  </div>
</template>

<script>
import { Capitalize } from '@/utils'
export default {
  props: {
    value: String,
  },
  data() {
    return {
      values: ['draft', 'unsigned', 'signed'],
    }
  },
  computed: {
    name() {
      return this.data
    },
  },
  methods: {
    Capitalize,
    isActive(item, value) {
      if (value === 'accepted' && item === 'signed') return true
      return item === value
    },
  },
}
</script>

<style lang="scss" scoped>
.status {
  $spacing: 0.25rem;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: -$spacing;

  font-size: 0.8em;

  & > *:not(svg) {
    margin: $spacing;
  }

  &__item {
    opacity: 0.5;
    transition-property: opacity, color, background-color;
    transition-timing-function: ease-out;
    transition-duration: 150ms;
    font-size: 0.9em;
    border-radius: 20px;
    padding: 3px 8px;

    &--active {
      color: var(--primary);
      background-color: hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.15);
      font-weight: bold;
      font-size: 1em;
      opacity: 1;
    }
  }

  & > svg {
    opacity: 0.3;
    margin: 1px;
  }
}
</style>
